import { login, getCurrentAdmin, refreshToken } from '@/api/admin'

const state = {
  token: '',
  refreshToken: '',
  adminInfo: {},
  permissions: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_REFRESH_TOKEN: (state, refreshToken) => {
    state.refreshToken = refreshToken
  },
  SET_ADMIN_INFO: (state, adminInfo) => {
    state.adminInfo = adminInfo
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  }
}

const actions = {
  // 登录
  login({ commit }, userInfo) {
    const { adminName, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ adminName: adminName.trim(), password: password }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.accessToken)
        commit('SET_REFRESH_TOKEN', data.refreshToken)
        commit('SET_ADMIN_INFO', data.adminInfo)
        // 设置默认权限，如果后端没有返回权限信息
        const permissions = data.permissions || ['SYSTEM_MANAGE', 'USER_MANAGE', 'GROUP_MANAGE']
        commit('SET_PERMISSIONS', permissions)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取管理员信息
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getCurrentAdmin().then(response => {
        const { data } = response
        if (!data) {
          reject('验证失败，请重新登录')
        }
        commit('SET_ADMIN_INFO', data)
        // 设置默认权限，如果后端没有返回权限信息
        const permissions = data.permissions || ['SYSTEM_MANAGE', 'USER_MANAGE', 'GROUP_MANAGE']
        commit('SET_PERMISSIONS', permissions)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 刷新token
  refreshToken({ commit, state }) {
    return new Promise((resolve, reject) => {
      refreshToken().then(response => {
        const { data } = response
        commit('SET_TOKEN', data.accessToken)
        commit('SET_REFRESH_TOKEN', data.refreshToken)
        commit('SET_ADMIN_INFO', data.adminInfo)
        commit('SET_PERMISSIONS', data.permissions)
        resolve()
      }).catch(error => {
        // 刷新失败，清除所有token信息
        commit('SET_TOKEN', '')
        commit('SET_REFRESH_TOKEN', '')
        commit('SET_ADMIN_INFO', {})
        commit('SET_PERMISSIONS', [])
        reject(error)
      })
    })
  },

  // 登出
  logout({ commit }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '')
      commit('SET_REFRESH_TOKEN', '')
      commit('SET_ADMIN_INFO', {})
      commit('SET_PERMISSIONS', [])
      resolve()
    })
  },

  // 重置token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_REFRESH_TOKEN', '')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
